import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  HiOutlineDuplicate,
  HiOutlineQrcode,
  HiX,
  HiOutlineShieldCheck,
  HiOutlineGlobeAlt
} from "react-icons/hi";
import { FaPaypal } from "react-icons/fa";
import yape from "../assets/yape_final.jpg";

// URL de tu QR real
const QR_YAPE_URL = yape;

const PaymentChannels = () => {
  const [showQrModal, setShowQrModal] = useState(false);

  const copyNumber = () => {
    navigator.clipboard.writeText("920238477");
    alert("Número 920238477 copiado al portapapeles.");
  };

  return (
    <div className="w-full max-w-6xl mx-auto py-10">
      <div className="text-center mb-12">
        <h2 className="text-3xl font-black text-[#1C1C1C] uppercase tracking-tighter">
          Selecciona tu método de pago
        </h2>
        <p className="text-gray-500 text-sm font-medium mt-2">Transacciones seguras con confirmación inmediata</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 px-2">

        {/* BLOQUE PERÚ: YAPE / PLIN / TRANSFERENCIA */}
        <div className="group p-8 md:p-10 rounded-[3.5rem] bg-gradient-to-br from-white to-gray-50 border-2 border-gray-100 hover:border-[#F26B1D]/20 transition-all shadow-xl shadow-gray-200/40">
          <div className="flex justify-between items-start mb-8">
            <span className="bg-[#F26B1D] text-white text-[10px] font-black px-4 py-1.5 rounded-full uppercase tracking-widest flex items-center gap-2">
              Perú 🇵🇪
            </span>
            <div className="flex gap-3">
              <img src="https://images.seeklogo.com/logo-png/39/1/yape-app-logo-png_seeklogo-399697.png" alt="Yape" className="h-8 w-auto object-contain" />
              <img src="https://images.seeklogo.com/logo-png/38/1/plin-logo-png_seeklogo-386806.png" alt="Plin" className="h-7 w-auto object-contain" />
            </div>
          </div>

          <h3 className="text-2xl font-black text-[#1C1C1C] mb-4">Soles (S/)</h3>
          <p className="text-gray-500 text-sm font-medium mb-8 leading-relaxed">
            Ideal para pagos rápidos en Perú. Aceptamos transferencias de todos los bancos nacionales y billeteras digitales.
          </p>

          {/* Acción de Pago Perú */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 items-center bg-white p-5 rounded-3xl border border-gray-100 shadow-sm">
            <div className="sm:col-span-2">
              <p className="text-[9px] font-black uppercase text-gray-400 tracking-widest mb-1">Número de celular</p>
              <div className="flex items-center gap-2">
                <span className="text-xl font-black text-[#1C1C1C]">920 238 477</span>
                <button onClick={copyNumber} className="p-2 text-gray-400 hover:text-[#F26B1D] transition-colors" title="Copiar número">
                  <HiOutlineDuplicate size={18} />
                </button>
              </div>
              <p className="text-[10px] font-bold text-gray-500 mt-1">Titular: AJGEO / Planix</p>
            </div>

            <div
              className="relative p-1 bg-gray-50 rounded-2xl border border-gray-200 cursor-pointer group/qr overflow-hidden w-20 h-20 mx-auto sm:mr-0"
              onClick={() => setShowQrModal(true)}
            >
              <img src={QR_YAPE_URL} alt="QR Yape" className="w-full h-full object-contain" />
              <div className="absolute inset-0 bg-[#F26B1D]/80 opacity-0 group-hover/qr:opacity-100 transition-opacity flex items-center justify-center">
                <HiOutlineQrcode className="text-white text-xl" />
              </div>
            </div>
          </div>

          <ul className="mt-8 space-y-3 border-t border-gray-100 pt-6">
            <li className="flex items-center gap-2 text-xs font-bold text-gray-600">
              <HiOutlineShieldCheck className="text-[#F26B1D]" /> Tipo de cambio: 1 USD = S/ 3.80 (aprox)
            </li>
            <li className="flex items-center gap-2 text-xs font-bold text-gray-600">
              <HiOutlineShieldCheck className="text-[#F26B1D]" /> Confirmación inmediata vía WhatsApp
            </li>
          </ul>
        </div>

        {/* BLOQUE EXTRANJERO: PAYPAL */}
        <div className="group p-8 md:p-10 rounded-[3.5rem] bg-[#1C1C1C] text-white border-2 border-transparent hover:border-[#F26B1D]/40 transition-all shadow-2xl shadow-black/20 flex flex-col justify-between">
          <div>
            <div className="flex justify-between items-start mb-8">
              <span className="bg-white/10 text-white text-[10px] font-black px-4 py-1.5 rounded-full uppercase tracking-widest flex items-center gap-2">
                Internacional 🌎
              </span>
              <div className="flex items-center gap-3 rounded-2xl border border-zinc-200 dark:border-zinc-700 bg-white dark:bg-zinc-900 px-5 py-3 shadow-md">
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/a/a4/Paypal_2014_logo.png"
                  alt="PayPal"
                  className="h-7 w-auto"
                />
              </div>
            </div>

            <h3 className="text-2xl font-black mb-4">Dólares (USD)</h3>
            <p className="text-gray-400 text-sm font-medium mb-8 leading-relaxed">
              Si te encuentras fuera de Perú, paga de forma segura con cualquier tarjeta de crédito o débito a través de PayPal.
            </p>
          </div>

          <div className="space-y-6">
            <a
              href="https://paypal.me/Alexjmaqui"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full bg-[#0070ba] hover:bg-[#005ea6] text-white py-4 rounded-2xl flex items-center justify-center gap-3 transition-all font-black uppercase text-xs tracking-widest shadow-lg shadow-blue-500/10 active:scale-95"
            >
              <FaPaypal /> Pagar con PayPal.me
            </a>

            <ul className="space-y-3 border-t border-white/5 pt-6">
              <li className="flex items-center gap-2 text-xs font-bold text-gray-300">
                <HiOutlineGlobeAlt className="text-[#F26B1D]" /> Pagos protegidos globalmente
              </li>
              <li className="flex items-center gap-2 text-xs font-bold text-gray-300">
                <HiOutlineGlobeAlt className="text-[#F26B1D]" /> Envío de archivos vía Email / WhatsApp
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* --- MODAL QR --- */}
      <AnimatePresence>
        {showQrModal && (
          <motion.div
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 bg-[#1C1C1C]/90 z-[100] flex items-center justify-center p-6 backdrop-blur-md"
            onClick={() => setShowQrModal(false)}
          >
            <motion.div
              initial={{ scale: 0.9, y: 20 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.9, y: 20 }}
              className="bg-white rounded-[3rem] p-8 md:p-10 max-w-sm w-full relative text-center"
              onClick={e => e.stopPropagation()}
            >
              <button onClick={() => setShowQrModal(false)} className="absolute top-6 right-6 p-2 bg-gray-100 rounded-full hover:bg-[#F26B1D] hover:text-white transition-colors">
                <HiX size={20} />
              </button>
              <p className="text-[10px] font-black uppercase text-[#F26B1D] tracking-[0.3em] mb-2">Escanea y Paga</p>
              <h4 className="text-2xl font-black text-[#1C1C1C] mb-8 tracking-tighter">Yape Oficial Planix</h4>
              <div className="bg-gray-50 p-4 rounded-3xl border border-gray-100 mb-6">
                <img src={QR_YAPE_URL} alt="QR Yape" className="w-full h-auto rounded-xl" />
              </div>
              <p className="text-xs text-gray-500 font-medium">Captura esta pantalla y usa la galería en tu app de Yape.</p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default PaymentChannels;